import WorkingHours from './WorkingHours.container'

export default WorkingHours;